import { parseWebStream } from 'music-metadata';
import { TIMEOUT } from '../../../constants';
import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';

const MAX_RETRIES_COUNT = 10;

export const fetchOgg = async ({
  abortController = new AbortController(),
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    abortController,
    parser: async (response) => {
      return new Promise<string | undefined>((resolve) => {
        const isOgg = response.headers.get('content-type')?.includes('ogg');
        if (!isOgg || !response.body) {
          resolve(undefined);
          return;
        }

        const timeout = setTimeout(() => {
          abortController.abort();
          resolve(undefined);
        }, TIMEOUT);

        let tries = 0;
        let collectedTitle: string, collectedArtist: string;
        parseWebStream(response.body, 'audio/ogg', {
          observer: ({
            metadata: {
              common: { title = '', artist = '' }
            }
          }) => {
            const overLimit = tries > MAX_RETRIES_COUNT;

            if ((!title || !artist) && !overLimit) {
              collectedTitle = title;
              collectedArtist = artist;

              tries += 1;

              return;
            }

            clearTimeout(timeout);

            if (overLimit) {
              abortController.abort();
              resolve(collectedTitle ?? collectedArtist);
            }

            abortController.abort();
            resolve(`${artist} - ${title}`);
          }
        });
      });
    }
  });
};
